import Autocomplete from '@webclient/components/search-forms/gamification-search/actions/bots-selector/sections/autocomplete';

export default function BotsSelector() {
  return <Autocomplete />;
}
